module.exports = __webpack_public_path__ + "img/entj.cb924f44.png";